import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';


import * as ProductActions from 'redux/modules/products';

import {Alert, OverlayTrigger, Tooltip, Tabs, Tab, Col, Row} from 'react-bootstrap';

import _ from 'underscore';

import {analyseState} from 'utils/analyseState';


import { translate } from 'react-i18next';

const FTP_TIMEOUT_MS = 60000;

@translate(['common'])
@connect(
  state => ({
  	smsActions:state.products.smsActions,
  	user:state.auth.user,
  	from:state.products.from,
  	intervalAfterReload:state.products.intervalAfterReload,
  	site_state:state.products.site_state,
  	mcpCalled:state.products.mcpCalled,
  }),
  dispatch=>bindActionCreators({...ProductActions}, dispatch)
)
export default class SiteStatePanel extends Component {

	constructor(props){
		super(props);
		
		this.intervalNumber = 0;
				
		this.state = {
			success: false,
			error: false,
			toggleActive:false
		};
		
		this.onToggle = this.onToggle.bind(this);
		this.ftpCall = this.ftpCall.bind(this);
	}
	
	componentDidMount(){ 

		var self = this;
		
		var actions = analyseState(this.props.state);						
		
		if( self.props.product ){
			var ficheID = self.props.product.s_id;
		} else {
			var ficheID = self.props.urlParams.ficheID;
		}
		
		var action;
		var hasCurrentAction = true;
		
		// Vérifier d'abord via site_state
		if(  actions.asts0.state == 1 ||  actions.asts0.state == 2 ) {
			action = 'asts0';
		} else if( actions.asts1.state == 1 ||  actions.asts1.state == 2) {
			action = 'asts1';
		} else if( actions.aspr0.state == 1 ||  actions.aspr0.state == 2) {
			action = 'aspr0';
		} else if( actions.aspr1.state == 1 ||  actions.aspr1.state == 2) {
			action = 'aspr1';
		} else {
			hasCurrentAction = false
		}
		
		// Vérifier aussi via smsActions (cas du retour sur l'onglet après changement)
		if (!hasCurrentAction && ficheID && this.props.smsActions && this.props.smsActions[ficheID]) {
			var smsActionsForSite = this.props.smsActions[ficheID];
			['asts0', 'asts1', 'aspr0', 'aspr1'].forEach(function(actionType) {
				if (smsActionsForSite[actionType] && smsActionsForSite[actionType].intervalLaunched && !smsActionsForSite[actionType].intervalFinished) {
					action = actionType;
					hasCurrentAction = true;
				}
			});
		}

		// Le polling n'est plus nécessaire - le WebSocket notifie directement les changements d'état
		 
	}
	

  componentWillUnmount(){
  	var siteId = this.props.product?.s_id;
  	if (siteId && this.props.smsActions?.[siteId]) {
  		_.each(this.props.smsActions[siteId], (action) => {
  			if (action?.interval) {
  				clearInterval(action.interval);
  			}
  		});
  	}
  	if (this.timeoutId) {
  		clearTimeout(this.timeoutId);
  	}
  	if (this.fallbackTimeoutId) {
  		clearTimeout(this.fallbackTimeoutId);
  	}
  }

  UNSAFE_componentWillMount(){
  	this.intervalNumber = 0;
  }



  componentDidUpdate(prevProps) {
  	var self = this;

  	var actions = analyseState(this.props.site_state);
  	var last_actions = analyseState(prevProps.site_state);

	const {t} = self.props
	
	// Détecter le succès/erreur via WebSocket ou polling (fonctionne aussi après F5)
	// Si l'état passe de 1/2 (en cours) à 3 (succès) ou >3 (erreur)
	if (this.props.site_state !== prevProps.site_state) {
		['asts0', 'asts1', 'aspr0', 'aspr1'].forEach((actionType) => {
			var currentState = actions[actionType].state;
			var previousState = last_actions[actionType].state;
			
			// Déterminer le label de l'action
			var modalBody = '';
			if (actionType === 'asts0') modalBody = t('siteStatePanel.deactivate_ftp');
			else if (actionType === 'asts1') modalBody = t('siteStatePanel.activate_ftp');
			else if (actionType === 'aspr0') modalBody = t('siteStatePanel.deactivate_ftp_prest');
			else if (actionType === 'aspr1') modalBody = t('siteStatePanel.activate_ftp');
			
			// Transition de "en cours" (1 ou 2) vers "succès" (3)
			if ((previousState === 1 || previousState === 2) && currentState === 3) {
				// Arrêter l'interval si présent
				var ficheID = self.props.product?.s_id || self.props.urlParams?.ficheID;
				if (ficheID && this.props.smsActions?.[ficheID]?.[actionType]?.interval) {
					clearInterval(this.props.smsActions[ficheID][actionType].interval);
					this.props.endInterval(actionType, ficheID);
				}
				this.intervalNumber = 0;
				self.props.loadProduct(self.props.product.id, self.props.urlParams);
				this.props.handleOpenModal(<span>{modalBody} {t("siteStatePanel.done")} <i className="text-success fa fa-check" aria-hidden="true"></i></span>);
				this.setState({ success: actions[actionType].stateLabel, error: false });
			}
			// Transition de "en cours" (1 ou 2) vers "erreur" (>3)
			else if ((previousState === 1 || previousState === 2) && currentState > 3) {
				var ficheID = self.props.product?.s_id || self.props.urlParams?.ficheID;
				if (ficheID && this.props.smsActions?.[ficheID]?.[actionType]?.interval) {
					clearInterval(this.props.smsActions[ficheID][actionType].interval);
					this.props.endInterval(actionType, ficheID);
				}
				this.intervalNumber = 0;
				this.props.handleOpenModal(<span>{modalBody} {actions[actionType].stateLabel} <i className="text-danger fa fa-times" aria-hidden="true"></i></span>);
				this.setState({ error: actions[actionType].stateLabel, success: false });
			}
		});
	}
  	
  	// Fallback: si mcpCalled vient de passer à true (SMS envoyé), lancer un timeout de sécurité
  	// Au cas où le WebSocket ne notifie pas (déconnexion, perte de room, etc.)
  	if (this.props.mcpCalled && !prevProps.mcpCalled && !this.fallbackTimeoutId) {
  		this.fallbackTimeoutId = setTimeout(() => {
  			// Si toujours en attente après 60s, vérifier l'état réel via loadProduct
  			if (this.props.mcpCalled) {
  				console.log('[SiteStatePanel] WS timeout fallback - reloading product');
  				self.props.loadProduct(self.props.product.id, self.props.urlParams);
  			}
  			this.fallbackTimeoutId = null;
  		}, 60000);
  	}
  	// Annuler le fallback si le WS a répondu (mcpCalled repassé à false)
  	if (!this.props.mcpCalled && prevProps.mcpCalled && this.fallbackTimeoutId) {
  		clearTimeout(this.fallbackTimeoutId);
  		this.fallbackTimeoutId = null;
  	}
  }
  
  
  ftpCall(event, type, ftpFieldsValid, hasValidIDPTU, isActivated) {

	const {t} = this.props

  	if(this.props.user.role == 'admin') {
  		var userId = this.props.urlParams.cid;
  	} else {
  		var userId = this.props.user.name;
  	}

  	var payload = {type, user:userId};
  	
  	if( this.props.mcpCalled == false && !this.props.hasCurrentFTPAction ) {
  		
  		if( type == 'aspr0' || type == 'aspr1' ) {
  			if( ftpFieldsValid == false ) {
  				this.props.handleOpenModal(<span>{t("main.please_fill_below")}</span>);
  				return;
  			} 
  		}
  		
  		if( hasValidIDPTU == false ) {
  			this.props.handleOpenModal(<span>{t("siteStatePanel.provide_valid_idptu_ftp")}</span>);
				return;
  		}
  	
	  	this.props.sendSMS(
			this.props.siteValues, 
			payload, 
			this.props.urlParams, 
			type, 
			this.props.state, 
			type, 
			"ftpPanel", 
			false, isActivated
		)
  	}
  	
  }
  
  onToggle() {
    this.setState({ toggleActive: !this.state.toggleActive });
  }

  render() {
  	var self = this;
  	var user = this.props.user;
  	var site = this.props.site; 
    var sFields = this.props.sFields;
    var etat_FTP = this.props.etat_FTP

	const {t} = this.props


    if(
  		(
	  		!sFields.identification_URL.invalid &&
				//!sFields.identification_FOLDER.invalid &&
				!sFields.identification_LOGIN.invalid &&
				!sFields.identification_PASS.invalid
			) && (
				(site.identification_URL != '' && site.identification_URL != null) &&
  			//(site.identification_FOLDER != '' && site.identification_FOLDER != null) &&
  			(site.identification_LOGIN != '' && site.identification_LOGIN != null) &&
  			(site.identification_PASS != '' && site.identification_PASS != null)
  		)
  	)
  	{
  		var ftpFieldsValid = true;
  	} else {
  		var ftpFieldsValid = false;
  	}
    
    var gsmDirty = this.props.pFields.identification_GSM.dirty;
    var id_ptu = this.props.product.identification_ID;
    var hasValidIDPTU = (id_ptu != '' && id_ptu != false && id_ptu !=null)  && this.props.pFields.identification_ID.invalid == false


    const  generateStateBtn = (btnInfo, disabled=false, states) => {
    	var self = this;

    	var params = this.props.urlParams;
    	var label = btnInfo.label;
    	var type = btnInfo.type.replace(/[0-9]/g, '');

    	var nbtype = parseInt(btnInfo.type.replace( /^\D+/g, ''));
    	var oppositeType = nbtype == 0 ? type+'1' : type+'0';
    	var siteID = self.props.product.s_id;
    	 

    	try {
    		var oppositeLaunched = this.props.smsActions[siteID][oppositeType].intervalLaunched == true
    	} catch(e){
    		var oppositeLaunched = false
    	}

    	var activationBtn = btnInfo.type.indexOf('1') > 0;    	 
    	var intervalLaunched = false;
    	
    	// Désactiver si action en cours (state 1 ou 2) - fonctionne aussi après F5
    	if (btnInfo.state == 1 || btnInfo.state == 2) {
    		disabled = true;
    	}
    	
    	if( siteID in this.props.smsActions && btnInfo.type in this.props.smsActions[siteID]) {
    		intervalLaunched = this.props.smsActions[siteID][btnInfo.type].intervalLaunched;
	    	if( this.props.smsActions[siteID][btnInfo.type].intervalLaunched == true
	    			|| oppositeLaunched == true
	    	) {
	    		disabled = true; 
	    	}
    	}

    	var addon = false;
    	
    	if( btnInfo.state == 0 ) {
    		var btnClass = 'btn-info';
    	}
    	else if( btnInfo.state == 1 || btnInfo.state == 2  ) {
    		var btnClass = 'btn-warning';
    	}
    	else if( btnInfo.state == 3 ) {
    		var btnClass = 'btn-success';
    	}
    	else {
    		var btnClass = 'btn-danger';
    	}

    	if( activationBtn ) {
    		var text = t("siteStatePanel.activate_the")+' '+label;
    		type = type + '1';
    		var actionLabel = t("siteStatePanel.activation_of")+' '+label;
    		//var btnClass = 'btn-success';
    	} else {
    		var text = t("siteStatePanel.deactivate_the") +' '+ label;
    		type = type + '0';
    		var actionLabel = t("siteStatePanel.deactivation_of") +' '+ label
    		//var btnClass = 'btn-danger';
    	}
    	var tooltipText = btnInfo.stateLabel;
    	var tooltip = <Tooltip id="tooltip"><strong>{tooltipText}</strong></Tooltip>

    	var addon =
	    	(<OverlayTrigger placement="top" overlay={tooltip}>
	    		<label className={"btn btn-default btn-sm "+btnClass}><i className="fa fa-info-circle"></i></label>
		    </OverlayTrigger>);

    	if(user.role == 'admin') {
    		var userId = params.cid;
    	} else {
    		var userId = user.name;
    	}

    	var payload = {type, user:userId};    	    	
    	var sameRequest = states[type].state == 3;
    	
    	return (
    		 
    		<div className="btn-group" data-toggle="buttons">
	    		<button key={'btn'+type} className={"btn btn-sm btn-primary"} type="button" onClick={() => {
	  				if( !disabled ){
	  					if( this.props.product ) {
	  						self.props.site.id = this.props.product.s_id
	  					}	  					
	    				this.props.sendSMS(self.props.siteValues, payload, params, type, this.props.state, actionLabel, "ftpPanel", sameRequest)
	    				self.btnClicked = type;
	  				} else {
	  					//
	  				}
	        }} disabled={disabled || self.props.mcpCalled || self.props.hasCurrentFTPAction}><i className={'fa ' + ((intervalLaunched || btnInfo.state == 1 || btnInfo.state == 2) ? 'fa-spinner fa-pulse' : '')}/> {text}
	        </button>
	        {addon}
    		</div>

    	);
    }

    //const styles = require('containers/Fiches/AddFiche.scss');

    var state = this.props.state;

    var ftpStates = analyseState(state); //decomposition de l'état

	var buttons = [];
	var states = [];

	var isAstsActivated = ftpStates.asts1.state == 3 || (etat_FTP == 1 || etat_FTP == 3 );
	var isAsprActivated =  ftpStates.aspr1.state == 3 || (etat_FTP > 1) || isAstsActivated;


	var astsButtons =(
		<div>
		
			{gsmDirty &&
				<Alert bsStyle="warning">
					<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> &nbsp;
					{t("siteStatePanel.desc1", {num:this.props.pFields.identification_GSM.initialValue})}						
				</Alert>
			
			}
			
			{
				generateStateBtn(
					ftpStates.asts1, 
					!(this.props.site.identification_GSM != '' && this.props.sFields.identification_URL.invalid == false), 
					ftpStates)
			}
			&nbsp;&nbsp;&nbsp;&nbsp;								
			{generateStateBtn(ftpStates.asts0, false, ftpStates)}
			
		</div>);
	

	var asprButtons =(
		<div>
			{generateStateBtn(ftpStates.aspr1, !ftpFieldsValid, ftpStates )}
			&nbsp;&nbsp;
			{generateStateBtn(ftpStates.aspr0, !isAsprActivated, ftpStates)}

		</div>);


	/*if ( ftpStates.asts1.state == 2 ) {
		astsGenState = 'Requête en cours'
	} else if(ftpStates.asts1.state == 3){
		astsGenState = 'FTP actif'
	}*/
	//var astsGenState = ftpStates.asts1.state == 3 ? 'FTP actif' : 'FTP inactif';
	//var asprGenState = ftpStates.aspr1.state == 3 ? 'FTP actif' : 'FTP inactif';
	
	var astsGenState = (etat_FTP == 1 || etat_FTP == 3)  ? <span>{t("switchButton.active_ftp")} <i className="fa fa-circle" aria-hidden="true" style={{color:'green'}}></i></span> : <span>{t("switchButton.inactive_ftp")} <i style={{color:'red'}} className="fa fa-circle" aria-hidden="true"></i></span>;
	var asprGenState = (etat_FTP == 2 ||  etat_FTP == 3) ? <span>{t("switchButton.active_ftp")} <i className="fa fa-circle" aria-hidden="true" style={{color:'green'}}></i></span> : <span>{t("switchButton.inactive_ftp")} <i style={{color:'red'}} className="fa fa-circle" aria-hidden="true"></i></span>;
			
	
	var tooltipASPR = ""//<strong>Le FTP AMPHITECH doit être activé pour paramétrer le FTP PRESTATAIRE</strong>
	/*var infoASPR = <OverlayTrigger placement="top" overlay={tooltipASPR}>
									<i className="fa fa-info-circle"></i>
								</OverlayTrigger>*/
	var infoASPR = '' 
	
	var prestLabel = <span> {t("siteStatePanel.ftp_presta")}</span> 
	
	
	var tooltipText1 = (etat_FTP == 1 || etat_FTP == 3) ? t("siteStatePanel.click_deactivate_ftp") : t("siteStatePanel.click_activate_ftp")
	
	var tooltip1 = <Tooltip id="tooltip"><strong>{tooltipText1}</strong></Tooltip>
	
	var tooltipText2 = (etat_FTP == 2 || etat_FTP == 3) ? t("siteStatePanel.click_deactivate_ftp") : t("siteStatePanel.click_activate_ftp")
		
	var tooltip2 = <Tooltip id="tooltip"><strong>{tooltipText2}</strong></Tooltip> 


	var toggleASTSOnText  = t("switchButton.active_ftp")
	var toggleASTSOffText = t("switchButton.inactive_ftp")
	
	var toggleASPROnText  = t("switchButton.active_ftp")
	var toggleASPROffText = t("switchButton.inactive_ftp")
	
	if( this.props.mcpCalled == true ) {
		
		if( 'asts1' in this.props.smsActions[self.props.product.s_id] ) { 
			if( this.props.smsActions[self.props.product.s_id].asts1.intervalLaunched ) {
				toggleASTSOnText = t("siteStatePanel.activate_ftp2")
				toggleASTSOffText = t("siteStatePanel.activate_ftp2")
			}
		}
		
		if( 'asts0' in this.props.smsActions[self.props.product.s_id] ) {
			if( this.props.smsActions[self.props.product.s_id].asts0.intervalLaunched ) {
				toggleASTSOnText  = t("siteStatePanel.deactivate_ftp2")
				toggleASTSOffText = t("siteStatePanel.deactivate_ftp2")
			}
		}
		
		toggleASTSOnText = <span>{toggleASTSOnText} <i className="fa  fa-spinner fa-pulse fa-1x"/></span>
		toggleASTSOffText = <span>{toggleASTSOffText} <i className="fa  fa-spinner fa-pulse fa-1x"/></span>
		
		if( 'aspr1' in this.props.smsActions[self.props.product.s_id] ) {
			if( this.props.smsActions[self.props.product.s_id].aspr1.intervalLaunched ) {
				toggleASPROnText = t("siteStatePanel.activate_ftp2")
				toggleASPROffText = t("siteStatePanel.activate_ftp2")
			}
		}
		
		if( 'aspr0' in this.props.smsActions[self.props.product.s_id] ) {
			if( this.props.smsActions[self.props.product.s_id].aspr0.intervalLaunched ) {
				toggleASPROnText  = t("siteStatePanel.deactivate_ftp2")
				toggleASPROffText = t("siteStatePanel.deactivate_ftp2")
			}
		}
		
		toggleASPROnText = <span>{toggleASPROnText} <i className="fa  fa-spinner fa-pulse fa-1x"/></span>
		toggleASPROffText = <span>{toggleASPROffText} <i className="fa  fa-spinner fa-pulse fa-1x"/></span>
		
	}
	
		
    return (
    	
    	<Col md={12}>
	    	<br/>
	    	<Row>
	    		   	    	
		    	<Tabs ref="tabStatePanel"  animation={false} id="controlled-tab-example">
	
				    <Tab eventKey={1} title={t("siteStatePanel.ftp_amphitech")} disabled={!isAstsActivated}>
				    	<div className="col-xs-12">
				    		<br/>
				    		
								<p><b>{astsGenState}</b></p>
								
								{/* 
								&nbsp;
								<SwitchButton action="asts"
									isActivated={(etat_FTP == 1 || etat_FTP == 3)}  
									ftpFieldsValid={ftpFieldsValid}
									hasValidIDPTU={hasValidIDPTU}
									mcpCalled={this.props.mcpCalled}
									ftpCall={this.ftpCall}
									smsActions={this.props.smsActions}
									site={this.props.siteValues}
								/>
								
								<OverlayTrigger placement="right" overlay={tooltip1}>
									<div id="astsToggle" className="col-xs-3">
										<Toggle
											on={toggleASTSOnText}
						          off={toggleASTSOffText}
						          size="sm"
						          offstyle="danger"
						          active={(etat_FTP == 1 || etat_FTP == 3)}
											width="165"
											height="40"
						        />
					        </div>
						   </OverlayTrigger>*/}
								
							{/*	<OverlayTrigger placement="right" overlay={tooltip1}>
									<div id="astsToggle" className="col-xs-3">
										<Toggle
						          onClick={(e)=>this.ftpCall(e, (etat_FTP == 1 || etat_FTP == 3)? 'asts0':'asts1', ftpFieldsValid, hasValidIDPTU)}}
											on={toggleASTSOnText}
						          off={toggleASTSOffText}
						          size="sm"
						          offstyle="danger"
						          active={(etat_FTP == 1 || etat_FTP == 3)}
											width="165"
											height="40"
						        />
					        </div>
						   </OverlayTrigger>*/}
									
									&nbsp;
									&nbsp;
									
									{/*<OverlayTrigger placement="right" overlay={tooltip1}>
										<i className="fa fa-info-circle"></i>
									</OverlayTrigger>*/}
	
								
								
								
							
								</div>
		      		<br/><br/>
		      		<div className="col-xs-10">
		      			{astsButtons}
		      			
		      			
		      			<br/><br/>
		      			{/*!isAstsActivated &&
		      				
		      				<Alert bsStyle="info">
				    				Le FTP AMPHITECH doit être activé pour paramétrer le FTP PRESTATAIRE
					  			</Alert>
		      				 
				    		*/}
				    	</div>
						</Tab>  
						
						
						{/*
						<Tab eventKey={2} disabled={true} title={prestLabel}>
							<div className="col-xs-12">
								<br/>
								<p><b>{asprGenState} </b></p>
								
								<Toggle
				          onClick={(e)=>this.ftpCall(e, (etat_FTP == 2 || etat_FTP == 3)? 'aspr0':'aspr1', ftpFieldsValid, hasValidIDPTU)} 
									on={toggleASPROnText}
				          off={toggleASPROffText}
				          size="sm"
				          offstyle="danger"
				          active={(etat_FTP == 2 || etat_FTP == 3)}
				          width="165"
		    					height="40"
		    					
				        />
			
	
								<SwitchButton action="aspr"
									isActivated={(etat_FTP == 2 || etat_FTP == 3)}  
									ftpFieldsValid={ftpFieldsValid}
									hasValidIDPTU={hasValidIDPTU}
									mcpCalled={this.props.mcpCalled}
									ftpCall={this.ftpCall}
									smsActions={this.props.smsActions}
									error={this.state.error}
								/>
		    				
		    				
		    				&nbsp;
		    				
		    				<OverlayTrigger placement="right" overlay={tooltip2}>
									<i className="fa fa-info-circle"></i>
								</OverlayTrigger>
								
								
								
								
							</div>
			    		<br/><br/>
			    		<div className="col-xs-12">
			    			{asprButtons}
			    			
			    			
			    			<br/>
			    			{ftpFieldsValid == false &&
			    				<div><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Vous devez renseigner les champs oranges ci-dessous pour pouvoir activer le FTP prestataire.</div>
			    			}
			    			
			    			<br/>
			    			{this.props.siteForm}
			    		</div>
			    		
						</Tab>
						
						*/}
	
		    	</Tabs>
	    	
	    	</Row>
	    	
	    	<Row>
	    	<Col md={6}>
		    	{/*(!this.state.success && this.state.error != false) &&
		    		<Alert bsStyle="danger" style={{margin:'0 0 0 -15px'}}>{this.state.error}</Alert>
		    	
		    	}
		    	
		    	{ this.state.success &&
		    		<Alert bsStyle="danger" style={{margin:'0 0 0 -15px'}}>{this.state.success}</Alert>
		    	*/}
		    	
	    	</Col>  
	    	</Row>
	    	 
	    	
	    	
	    </Col>

    );
  }
}
